module.exports = __webpack_public_path__ + "img/Tool-shape.b4c4c59a.svg";